import React from "react";
import {Button, ButtonGroup, Div, FormItem, Input, List, SimpleCell, Switch, Title} from "@vkontakte/vkui";
import {AdaptivityContext} from "../assets/constants";
import axios from "axios";

class FileSender extends React.Component {

    state = {
        enabledEmails: {}
    }

    constructor(props) {
        super(props);
    }


    render() {
        const count = this.props.emails.reduce((sum,email) => sum+(email?1:0), 0 )
        return (
            <Div>
                <FormItem top="Выслать файл на email">
                    <Input type="email" value={this.state.email}
                           onChange={e => this.setState({email: e.currentTarget.value})}/>
                </FormItem>
                {count && <h4>Добавить в копию получаталей:</h4>}
                <List>
                    {
                        this.props.emails.map(email => (
                            email&&<SimpleCell Component="label" multiline
                                        after={<Switch size={5} checked={this.state.enabledEmails[email]}
                                                       onChange={() => this.toggleEmail(email)}/>}>
                                {email}
                            </SimpleCell>
                        ))
                    }
                </List>
                <ButtonGroup stretched>
                    <Button size="l" mode="outline" onClick={() => this.sendFile()}>
                        Выслать
                    </Button>
                    {!AdaptivityContext.isMobile
                        && <Button size="l" mode="outline" onClick={() => window.open(this.props.file.meta.filename)}>
                            Скачать
                        </Button>}
                    <Button size="l" mode="outline" onClick={() => this.props.close()}>
                        Отмена
                    </Button>
                </ButtonGroup>
            </Div>
        );
    }

    sendFile = () => {

        const body = new FormData()

        if (this.props.id) {
            body.append('id', this.props.id)
        }
        const emails = []
        this.props.emails.map(email => {
            if (this.state.enabledEmails[email])
                emails.push(email)
        })

        if (this.state.email) {
            emails.push(this.state.email)
        }

        if (emails.length >0) {
            body.append('emails', JSON.stringify(emails))

            axios.post(this.props.base_url + '?app=saledocs&act=sendFileToEmail', body,
                {
                    withCredentials: true

                }
            ).then((response) => {
                if (response.data.success) {
                    window.postMessage({type: 'success', text: 'Письма со счетом успешно отправлены', timeout: 2000})
                } else {
                    window.postMessage({
                        type: 'error',
                        text: response.data.error || 'Скачивание счета невозможно — не корректно проставлены цены',
                        timeout: 8000
                    })
                }
            })
        } else {
            window.postMessage({
                type: 'error',
                text: 'Укажите хотя бы один email из списка или введите email вручную',
                timeout: 5000
            })
        }


    }
    toggleEmail = (email) => {
        const old = this.state.enabledEmails
        old[email] = old[email] ? 0 : 1
        this.setState({enabledEmails: old})
    }
}

export default FileSender